module.exports = __webpack_public_path__ + "static/media/drager-logo-charcoal.48e59f7b.svg";